export const buildAlertaObj = (
    paramTitulo,
    paramConteudo,
    paramListaBotoes,
    paramExtraMensagem = ''
) => {
    let localConteudo = paramConteudo;
    if (!Array.isArray(paramConteudo)) {
        localConteudo = [localConteudo];
    }
    return {
        titulo: paramTitulo,
        conteudo: localConteudo,
        botoes: paramListaBotoes,
        extraMensagem: paramExtraMensagem
    };
};

const erroGenerico = () => {
    return buildAlertaObj(
        'Ocorreu um erro inesperado',
        'Por favor tente novamente.'
    );
};

const erro401 = () => {
    const botoes = [
        {
            texto: 'Relogar',
            click: () => {}
        }
    ];
    return buildAlertaObj(
        'Acesso expirado',
        'Acesso ao portal expirado. É necessário fazer o Login na aplicação novamente!',
        botoes,
        'LOGOUT'
    );
};

const erro405 = paramPermissoes => {
    return buildAlertaObj(
        'Acesso negado!',
        'Você não pode realizar essa ação!',
        undefined,
        { key: 405, permissoes: JSON.parse(paramPermissoes) }
    );
};

export const tratarErro = error => {
    if (error.response && error.response.status) {
        if (error.response.status === 500) {
            return erroGenerico();
        }

        if (error.response.status === 401 || error.response.status === 403) {
            return erro401();
        }

        if (error.response.status === 405) {
            return erro405(error.response.data.message);
        }
    } else {
        return erroGenerico();
    }

    return null;
};
